import { FC, ReactNode } from "react";
import { useBackfillStore } from "../../store/backfillsStore";
import { CommonDiagram } from "./CommonDiagram";

interface IDynamicDiagram {
  fullWidth?: boolean;
  fullScreenButton: ReactNode;
  showIcons: boolean;
}

const DynamicDiagram: FC<IDynamicDiagram> = ({ fullWidth, fullScreenButton, showIcons }) => {
  const updateGraph = useBackfillStore((state) => state.updateGraph);
  return (
    <CommonDiagram
      fullScreenButton={fullScreenButton}
      onClickNode={updateGraph}
      fullWidth={fullWidth}
      showIcons={showIcons}
      type="dynamic"
    />
  );
};

export { DynamicDiagram };
